<h1 mat-dialog-title color="primary">Submission Successful!</h1>
<mat-dialog-content class="dialog-header dialog-footer">
    Your dataset has been successfully submitted. It may take time to process but you can close this message and return to your dashboard to check the status.
</mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button class='close-button' color="primary" (click)="onSuccess()">Close</button>
    </mat-dialog-actions>